import { axiosInstance } from './axios';

let interceptorsInitialized = false;

export function setupAxiosInterceptors() {
  if (interceptorsInitialized) return;
  interceptorsInitialized = true;

  axiosInstance.interceptors.request.use(
    (config) => {
      if (config.url?.includes('Login') || config.url?.includes('Public')) {
        return config;
      }

      const authToken = localStorage.getItem('authToken');
      if (authToken) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      console.log('[API SUCCESS]', response.config.url, response.status);
      return response;
    },
    (error) => {
      const status = error.response?.status;
      const url = error.config?.url || '';
      const errorCode = error.response?.data?.errorCode;

      console.log(
        '[API ERROR]',
        url,
        'status:',
        status,
        'errorCode:',
        errorCode,
        'data:',
        JSON.stringify(error.response?.data)
      );

      const isPlaidEndpoint = url.includes('Plaid/');
      const isDomainSpecific401 = status === 401 && !!errorCode;
      const shouldLogOutOnAuthFailure =
        status === 401 && !isPlaidEndpoint && !isDomainSpecific401;

      if (shouldLogOutOnAuthFailure) {
        console.warn(
          '401 received - clearing session and redirecting to sign in'
        );
        Object.keys(localStorage)
          .filter(
            (k) => k.startsWith('@@auth0spajs@@') || k.startsWith('auth0.')
          )
          .forEach((k) => localStorage.removeItem(k));

        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('userLoggedIn');
        localStorage.removeItem('appBackgroundedAt');

        sessionStorage.clear();
        sessionStorage.setItem('force_manual_login', '1');

        window.location.href = '/';
      }

      return Promise.reject(error);
    }
  );

  // axiosInstance.interceptors.response.use(
  //   (response) => {
  //     console.log('[API SUCCESS]', response.config.url, response.status);
  //     return response;
  //   },
  //   (error) => {
  //     console.log('[API ERROR]', error.config?.url, 'status:', error.response?.status, 'data:', JSON.stringify(error.response?.data));
  //     if (error.response?.status === 401) {
  //       console.warn(
  //         '401 received - clearing session and redirecting to sign in'
  //       );
  //        Object.keys(localStorage)
  //         .filter(k => k.startsWith('@@auth0spajs@@') || k.startsWith('auth0.'))
  //         .forEach(k => localStorage.removeItem(k));

  //       localStorage.removeItem('authToken');
  //       localStorage.removeItem('userInfo');
  //       localStorage.removeItem('userLoggedIn');
  //       localStorage.removeItem('appBackgroundedAt');

  //       sessionStorage.clear();
  //       sessionStorage.setItem('force_manual_login', '1');

  //       window.location.href = '/';
  //     }
  //     return Promise.reject(error);
  //   }
  // );
}

// import { axiosInstance } from './axios';

// let interceptorsInitialized = false;

// export function setupAxiosInterceptors() {
//   if (interceptorsInitialized) return;
//   interceptorsInitialized = true;

//   axiosInstance.interceptors.request.use(
//     (config) => {
//       if (config.url?.includes('Login') || config.url?.includes('Public')) {
//         return config;
//       }

//       const authToken = localStorage.getItem('authToken');
//       if (authToken) {
//         config.headers = config.headers || {};
//         config.headers.Authorization = `Bearer ${authToken}`;
//       }

//       return config;
//     },
//     (error) => Promise.reject(error)
//   );
// }
